import { useDataProvider, useListContext, useNotify, useRefresh, useTranslate, useUnselectAll } from 'react-admin';
import { CustomButton } from '@/components/global/buttons/CustomButton.jsx';
import PropTypes from 'prop-types';
import RefreshIcon from '@/assets/icons/refresh-icon.svg?react';
import DisactiveIcon from '@/assets/icons/disactive-icon.svg?react';

export const RotateActionButton = ({ id }) => {
    return (
        <ActionButton
            label='resources.accessKey.labels.generateNew'
            icon={<RefreshIcon />}
            resource='access-key'
            ids={id ? [id] : null}
            action='rotate'
            successMessage={id ? 'resources.accessKey.notifications.rotateSuccess' : 'resources.accessKey.notifications.manyRotateSuccess'}
        />
    );
};

RotateActionButton.propTypes = {
    id: PropTypes.string,
};

export const RevokeActionButton = ({ id }) => {
    return (
        <ActionButton
            label='resources.accessKey.labels.revoke'
            icon={<DisactiveIcon />}
            resource='access-key'
            ids={id ? [id] : null}
            action='revoke'
            successMessage={id ? 'resources.accessKey.notifications.revokeSuccess' : 'resources.accessKey.notifications.manyRevokeSuccess'}
        />
    );
};

RevokeActionButton.propTypes = {
    id: PropTypes.string,
};

export const BulkActionButtons = () => {
    return (
        <>
            <RotateActionButton />
            <RevokeActionButton />
        </>
    );
};

BulkActionButtons.propTypes = {};

const SingleActionButton = ({ label, icon, resource, id, action, successMessage }) => {
    const notify = useNotify();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();

    const handleClick = () => {
        dataProvider
            .updateMany(resource, {
                data: {
                    ids: [id],
                    action: action,
                },
            })
            .then(() => {
                notify(successMessage);
                refresh();
            })
            .catch(error => {
                notify(`${translate('common.errorOccurred')}: ${error.message}`, { type: 'error' });
            });
    };

    return (
        <CustomButton label={translate(label)} variant='text' onClick={handleClick}>
            {icon}
        </CustomButton>
    );
};

const BulkActionButton = ({ label, icon, resource, action, successMessage }) => {
    const notify = useNotify();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
    const { selectedIds } = useListContext();
    const unselectAll = useUnselectAll(resource);

    const handleClick = () => {
        dataProvider
            .updateMany(resource, {
                data: {
                    ids: selectedIds,
                    action: action,
                },
            })
            .then(() => {
                notify(successMessage);
                refresh();
                unselectAll();
            })
            .catch(error => {
                notify(`${translate('common.errorOccurred')}: ${error.message}`, { type: 'error' });
            });
    };

    return (
        <CustomButton label={translate(label)} variant='text' onClick={handleClick}>
            {icon}
        </CustomButton>
    );
};

const ActionButton = ({ label, icon, resource, ids, action, successMessage }) => {
    if (ids && ids.length > 0) {
        return <SingleActionButton label={label} icon={icon} resource={resource} id={ids[0]} action={action} successMessage={successMessage} />;
    }
    return <BulkActionButton label={label} icon={icon} resource={resource} action={action} successMessage={successMessage} />;
};

ActionButton.propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    resource: PropTypes.string.isRequired,
    ids: PropTypes.arrayOf(PropTypes.string),
    action: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
};
